export const DISPLAY_TYPE = {
  SPLIT: 'split',
  MERGED: 'merged',
};
